module.exports = __webpack_public_path__ + "static/media/background-onboarding.a54016ae.png";